import React, { useEffect, useState } from "react"
import useWindowResize from "@/hooks/useWindowResize"
import Dropdown from "@/components/core/SelectDropdown/SelectDropdown"
import styles from "@/components/AccountsLayoutNonLoggedIn/index.module.scss"
import {
  selectAuthState,
  setAuthModalVisibility,
} from "@/store/features/authSlice"
import { useDispatch, useSelector } from "react-redux"

const AccountsLayoutNonLoggedIn = ({
  i18n,
  title,
  user,
  isAuth,
  logout,
  redirect,
  ...props
}) => {
  const [width] = useWindowResize()
  const [activeTab, setActive] = useState(props.activeTab ?? 2)
  const [origin, setOrigin] = useState("")
  const [isMobile, setIsMobile] = useState(width <= 1203)
  const dispatch = useDispatch()
  const { authModal: { show } = {} } = useSelector(selectAuthState)

  const data = [
    {
      title: "Sign In",
    },
    {
      title: "Create Account",
    },
    {
      title: "Orders",
    },
  ]
  useEffect(() => {
    setIsMobile(width <= 1024)
  }, [width])

  useEffect(() => {
    setOrigin(window.location.origin)
  }, [])
  useEffect(() => {
    if (!show) setActive(2)
  }, [show])
  const handleChange = index => {
    setActive(index)
    if (index === 0 || index === 1) {
      dispatch(setAuthModalVisibility({ show: true, active: index }))
    }
  }

  const handleClick = index => {
    dispatch(setAuthModalVisibility({ show: true, active: index }))
  }
  return (
    <div className={`${styles.accountTabsWrapper} `}>
      <div className="account-tabs__main-content">
        <aside className="col-lg-3 account-tabs__nav-wrapper">
          <div className="account-tabs__nav">
            {!isMobile ? (
              <>
                {" "}
                <div
                  id="kf-user-name"
                  className="account-tabs__message"
                  tabIndex="0"
                  role="alert"
                >
                  {`${i18n.yourKohlerAccount}`}
                </div>
                <div
                  id="kf-user-name"
                  className="account-tabs__text"
                  tabIndex="0"
                  role="alert"
                  onClick={() => handleClick(0)}
                >
                  {`${i18n.signIn}`}
                </div>
                <div className="account-tabs__horizontal-line"></div>
                <div
                  id="kf-user-name"
                  className="account-tabs__text"
                  tabIndex="0"
                  role="alert"
                  onClick={() => handleClick(1)}
                >
                  {`${i18n.createAccount}`}
                </div>
                <div className="account-tabs__horizontal-line"></div>
                <div
                  id="kf-user-name"
                  className="account-tabs__text account-tabs__active"
                  tabIndex="0"
                  role="alert"
                >
                  {`${i18n.orders}`}
                </div>
                <div className="account-tabs__horizontal-line"></div>
              </>
            ) : (
              <div className="account-tabs__dropdown">
                <div className="account-tabs__heading">
                  {i18n.yourKohlerAccount}
                </div>
                <Dropdown
                  id="account-tab"
                  data={data?.map(item => item.title)}
                  value={data[activeTab] ? data[activeTab].title : ""}
                  label={"My Account"}
                  onChange={val =>
                    handleChange(data.findIndex(obj => obj.title === val))
                  }
                />
              </div>
            )}
          </div>
        </aside>
        <main className="col-lg-9 account-tabs__wrapper-nav">
          <div className="account-tabs__content">{props.children}</div>
        </main>
      </div>
    </div>
  )
}

export default AccountsLayoutNonLoggedIn
